export class TemplateHelpPlanModel{
    thpTemplateId: string;
    thpHelpPlanId: string;
}